export const checkObject = (v) => v && typeof v === 'object' && Object.keys(v).length > 0;

export const formatQuestionTitle = (title) => title.substring(0, title.length - 1);

export const EVALUATION_YEARS = ['2023', '2024'];

export const isEvaluationYear = (year) => EVALUATION_YEARS.includes(year);
